const apiUrl = process.env.REACT_APP_API_URL;
export const PostJutgePracticaIdDocumentId = async (id_practica: string, id_document: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/practica/${id_practica}/document/${id_document}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
